import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgPipesModule } from 'ngx-pipes';

// MOUDULES
import { CoreModule } from '@app/core/core.module';
import { LuminousV2Module } from 'v2/luminous-v2.module';

import { CustomFieldRoutingModule } from './custom-field-routing';

// MATERIAL MODULES

const angularModules = [CommonModule];
const libModules = [NgPipesModule];
const lumModules = [CoreModule, LuminousV2Module];
const routingModules = [RouterModule, CustomFieldRoutingModule];

@NgModule({
  imports: [...angularModules, ...libModules, ...lumModules, ...routingModules],
})
export class CustomFieldModule {}
